module.exports = __webpack_public_path__ + "img/vanuaty.0bec2d38.svg";